// Recovered compiled webpack factory 20063. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  var n = r(47260);
  (r.o(n, "useParams") &&
    r.d(t, {
      useParams: function () {
        return n.useParams;
      },
    }),
    r.o(n, "usePathname") &&
      r.d(t, {
        usePathname: function () {
          return n.usePathname;
        },
      }),
    r.o(n, "useRouter") &&
      r.d(t, {
        useRouter: function () {
          return n.useRouter;
        },
      }),
    r.o(n, "useSearchParams") &&
      r.d(t, {
        useSearchParams: function () {
          return n.useSearchParams;
        },
      }));
}
